<div class="cv-card">
  <div class="cv-header">
    <span class="cv-title">Critical Values — t-Distribution</span>
  </div>

  <div class="cv-scroll">
    <table class="cv-table">
      <thead>
        <tr>
          <th class="cv-corner">df \ α</th>
          @for (col of columns; track col.twoTailed; let ci = $index) {
            <th
              class="cv-alpha"
              [class.hl-col]="isHighlightCol(ci)"
              [class.hover-col]="isHoverCol(ci)"
              (mouseenter)="onColumnEnter(ci)"
              (mouseleave)="onColumnLeave()"
            >
              {{ col.twoTailed }}
            </th>
          }
        </tr>
      </thead>

      <tbody>
        @for (row of rows; track row.label; let ri = $index) {
          <tr [class.hl-row]="isHighlightRow(ri)" [class.z-row]="row.df === null">
            <td class="cv-df">{{ row.label }}</td>
            @for (val of row.values; track $index; let ci = $index) {
              <td
                class="cv-val"
                [class.hl-col]="isHighlightCol(ci)"
                [class.hover-col]="isHoverCol(ci)"
                [class.hl-cell]="isHighlightCell(ri, ci)"
                (mouseenter)="onColumnEnter(ci)"
                (mouseleave)="onColumnLeave()"
              >
                {{ val }}
              </td>
            }
          </tr>
        }
      </tbody>

      <tfoot>
        <tr class="cv-footer">
          <td class="cv-df cv-footer-label">α (1-tail)</td>
          @for (col of columns; track col.twoTailed; let ci = $index) {
            <td
              class="cv-val cv-footer-val"
              [class.hover-col]="isHoverCol(ci)"
              (mouseenter)="onColumnEnter(ci)"
              (mouseleave)="onColumnLeave()"
            >
              {{ col.oneTailed }}
            </td>
          }
        </tr>
      </tfoot>
    </table>
  </div>
</div>
